import { useEffect } from 'react';
import api from '../../../services/api';

const DEFAULT_DESC = 'VyomOS — the operating system for sports academies.';
let pagesPromise = null;
const loadPages = () => {
  if (!pagesPromise) pagesPromise = api.get('/public/website/pages').then((r) => r.data.pages || []).catch(() => []);
  return pagesPromise;
};

const setTag = (selector, create, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
};

// Per-page <head>: title, description, canonical, robots. Unknown, draft or empty pages → noindex.
export function usePageSeo(slug, { empty = false } = {}) {
  useEffect(() => {
    let alive = true;
    loadPages().then((pages) => {
      if (!alive) return;
      const p = pages.find((x) => x.slug === slug);
      const title = p?.meta_title || (p ? `${p.title} · VyomOS` : 'VyomOS');
      document.title = title;
      const desc = p?.meta_description || DEFAULT_DESC;
      setTag('meta[name="description"]', () => Object.assign(document.createElement('meta'), { name: 'description' }), 'content', desc);
      setTag('meta[property="og:description"]', () => { const m = document.createElement('meta'); m.setAttribute('property', 'og:description'); return m; }, 'content', desc);
      setTag('meta[property="og:title"]', () => { const m = document.createElement('meta'); m.setAttribute('property', 'og:title'); return m; }, 'content', title);
      const canonical = p?.canonical_url || `https://vyomos.io/${slug === 'home' ? '' : slug}`;
      setTag('link[rel="canonical"]', () => Object.assign(document.createElement('link'), { rel: 'canonical' }), 'href', canonical);
      const noindex = !p || p.noindex || empty;
      setTag('meta[name="robots"]', () => Object.assign(document.createElement('meta'), { name: 'robots' }), 'content', noindex ? 'noindex, follow' : 'index, follow');
    });
    return () => { alive = false; };
  }, [slug, empty]);
}

export const useNoIndex = () => {
  useEffect(() => {
    setTag('meta[name="robots"]', () => Object.assign(document.createElement('meta'), { name: 'robots' }), 'content', 'noindex, nofollow');
  }, []);
};
